import {UI, registerStyle, styleRule, StyleSheet} from "../../../../stem-core/src/ui/UI";
import {Dispatcher} from "../../../../stem-core/src/base/Dispatcher";

import {RollAnimatedBalance} from "../../../common/RollAnimatedBalance";
import {AddFundsExpanded, MakeLargeWalletBalanceStyle} from "./sections/AddFundsExpanded";
import {TopUpPaymentStore, PaymentMethodStore} from "../../../State";
import {AddFundsMinimised, minimisedBalanceStyle} from "./sections/AddFundsMinimised";
import {WidgetActiveRouteElement} from "../../ui/WidgetActiveRouteElement";
import {isSmallScreen} from "../../../Utils";
import {Device} from "../../../../stem-core/src/base/Device";
import {Router} from "../../../../stem-core/src/ui/Router";
import {TopUpStatus} from "../../../../client/state/TopUpPaymentStore";
import {autoredraw} from "../../../../stem-core/src/decorators/AutoRedraw.js";


class AddFundsStyle extends StyleSheet {
    @styleRule
    container = {
        background: this.themeProps.WALLET_GRADIENT_BACKGROUND,
        height: 39, // TODO @cleanup all instances of 39 are a terrible practice
        overflow: "hidden",
        borderRadius: 0,
        bottom: 0,
        transition: this.themeProps.DEFAULT_TRANSITION,
    };

    @styleRule
    elementExpanded = {
        height: "100%",
        borderRadius: () => isSmallScreen() && !Device.isLandscape() ? 0 : "12px 12px 0 0",
        ">:first-child": {
            opacity: 1,
            zIndex: 2,
        },
        ">:nth-child(2)": {
            opacity: 0,
        },
        ">:last-child": {
            ...MakeLargeWalletBalanceStyle(this.themeProps),
            marginBottom: 0,
            width: "100% !important",
            left: 0,
            zIndex: 3,
        },
    };

    @styleRule
    addFunds = {
        visibility: "hidden",
        transition: this.themeProps.DEFAULT_TRANSITION,
        position: "absolute",
        top: 0,
        height: "initial !important",
        minHeight: "100%",
    };

    @styleRule
    animationBalance = {
        ...minimisedBalanceStyle,
        transition: this.themeProps.DEFAULT_TRANSITION,
        position: "absolute !important",
        left: 24,
        bottom: 13,
        zIndex: 0,
    };
}

@registerStyle(AddFundsStyle)
@autoredraw(PaymentMethodStore)
export class AddFunds extends WidgetActiveRouteElement {
    shouldCollapseAddFunds = false;
    expandedAddFunds = false;

    extraNodeAttributes(attr) {
        super.extraNodeAttributes(attr);
        if (this.expandedAddFunds && this.addFunds && this.addFunds.balance) {
            attr.addClass(this.styleSheet.elementExpanded);
            this.addFunds.setStyle("visibility", "visible");
            this.attachTimeout(() => {
                const addFundsRect = this.addFunds.node.getBoundingClientRect();
                const balanceRect = this.addFunds.balance.node.getBoundingClientRect();
                this.balance.setStyle("bottom", addFundsRect.bottom - balanceRect.bottom);
            });
        }
    }

    render() {
        const {styleSheet} = this;

        return [
            <AddFundsExpanded ref="addFunds" className={styleSheet.addFunds}/>,
            <AddFundsMinimised />,
            <RollAnimatedBalance ref="balance" className={styleSheet.animationBalance} />,
        ];
    }

    static show(options) {
        const {instance} = this;
        instance.expandedAddFunds = true;
        instance.updateOptions(options);
    }

    static hide() {
        const {instance} = this;
        instance.expandedAddFunds = false;
        instance.redraw();
    }

    computeHeight() {
        return this.addFunds.computeHeight();
    }

    onMount() {
        super.onMount();

        this.attachChangeListener(TopUpPaymentStore, transaction => {
            if (transaction && transaction.status === TopUpStatus.SUCCEEDED) {
                Dispatcher.Global.addListenerOnce("balanceAnimationFinished", () => {
                    if (this.shouldCollapseAddFunds && this.expandedAddFunds) {
                        Router.back();
                    }
                    this.shouldCollapseAddFunds = false;
                });
            }
        });

        // TODO @cleanup delete this shit
        this.attachListener(Dispatcher.Global, "shouldCollapseAddFunds", () => {
            this.shouldCollapseAddFunds = true;
        });
    }
}
